/**
 * Nombre de archivo para una nota de voz grabada con `MediaRecorder`.
 *
 * POR QUÉ ES UN MÓDULO Y NO TRES LÍNEAS EN EL GRABADOR
 * ---------------------------------------------------
 * El contenedor que produce `MediaRecorder` DEPENDE DEL NAVEGADOR y no se
 * puede asumir:
 *
 *   Chrome / Edge → `audio/webm;codecs=opus`
 *   Firefox       → `audio/ogg; codecs=opus`   (no soporta el webm que pedimos)
 *   Safari        → `audio/mp4`
 *
 * La extensión tiene que seguir al contenido REAL, no al que pedimos. Cuando
 * no lo hacía, en Firefox se grababa OGG y se subía como `.webm`: el backend
 * sniffea los bytes (`application/ogg`), su conversor a OGG-Opus para WhatsApp
 * sólo se dispara sobre contenedores webm, y `GetMediaTypeFromMime` manda todo
 * lo que no empieza con `audio/` a la categoría **documento**. Resultado: la
 * nota de voz salía como archivo adjunto, o Meta la rechazaba por desacuerdo
 * entre el mimetype declarado y el que ve al procesarla.
 *
 * El prefijo `voice_` tampoco es cosmético: es la última red del backend
 * (`shouldTreatWebMAsVoice`) para reconocer una nota de voz cuando el sniff
 * dice `video/webm` —lo que devuelve para CUALQUIER contenedor webm, incluido
 * uno de sólo audio— y el header multipart no aclara nada. Ese chequeo busca
 * `voice_` con guion BAJO; el nombre que mandábamos (`voice-note-…`) no
 * coincidía nunca, así que la red no existía.
 */

/** Extensión que corresponde al contenedor realmente grabado. */
export function voiceNoteExtension(mimeType: string | undefined | null): string {
  const tipo = (mimeType ?? '').toLowerCase();
  if (tipo.includes('ogg')) return 'ogg';
  // Safari graba `audio/mp4`; `.m4a` es el nombre que esperan los reproductores.
  if (tipo.includes('mp4') || tipo.includes('m4a') || tipo.includes('aac')) return 'm4a';
  if (tipo.includes('mpeg') || tipo.includes('mp3')) return 'mp3';
  if (tipo.includes('wav')) return 'wav';
  return 'webm';
}

/**
 * Nombre completo. `timestamp` se recibe por parámetro para que la función sea
 * pura y testeable.
 */
export function voiceNoteFileName(
  mimeType: string | undefined | null,
  timestamp: number,
): string {
  return `voice_note_${timestamp}.${voiceNoteExtension(mimeType)}`;
}
